// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3cYw-","list":"PatternAutocomplete_list__2LhVS"};